export const sessionStorageGet = (key: string) => {
  const value = sessionStorage.getItem(key);
  if (!value) return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

export const sessionStorageSet = (key: string, value: any) => {
  if (typeof value === "object") value = JSON.stringify(value);
  sessionStorage.setItem(key, value);
};

export const sessionStorageRemove = (key: string) => {
  sessionStorage.removeItem(key);
};
